export default __webpack_public_path__ + "static/media/glrc-course.plant-based-stock-sauces-soups.cff43f28.png";